import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type GlobalSearchItemMetadata } from '../../../../../../value-objects/GlobalSearchItemMetadata'

const EXTERNAL_PAYMENT_METHOD = 'external'

export const useFormatGlobalSearchIdentifierLabel = () => {
  const intl = useProcurifyIntl()

  return (metadata: GlobalSearchItemMetadata): Nullable<string> => {
    if ('invoiceNumber' in metadata) {
      return intl.formatMessage(messages.invoiceNumberLabel, {
        invoiceNumber: metadata.invoiceNumber,
      })
    }

    if ('vendorPaymentMethod' in metadata) {
      return metadata.vendorPaymentMethod === EXTERNAL_PAYMENT_METHOD
        ? intl.formatMessage(messages.externalPaymentMethodLabel)
        : metadata.vendorPaymentMethod
    }

    if ('sku' in metadata) {
      return metadata.sku
    }

    if ('externalId' in metadata && metadata.externalId) {
      return metadata.externalId
    }

    return null
  }
}
